// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DdjDocumentCore, DdjTemplate } from '@interfaces/document.interfaces';
import { takeWhile } from 'rxjs/operators';
import { DocumentsService } from '@services/documents.service';

enum ViewState {
    success = 'success',
    confirm = 'confirm',
}

@Component({
    selector: 'app-delete-template-modal',
    templateUrl: './delete-template-modal.component.html',
    styles: [
        `
            .template-name-category {
                background-color: #f7f7f7;
                padding: 0.3rem 1rem;
                margin-bottom: 1rem;
            }
        `,
    ],
})
export class DeleteTemplateModalComponent implements OnDestroy {
    viewStates = ViewState;
    viewState = ViewState.success;
    private isComponentAlive = true;
    public forms: DdjDocumentCore[] = [];

    constructor(
        private readonly dialogRef: MatDialogRef<DeleteTemplateModalComponent>,
        private readonly documentsService: DocumentsService,
        @Inject(MAT_DIALOG_DATA) public form: { DdjTemplate; dealerId; commonDocument }
    ) {
        dialogRef.disableClose = true;
    }

    deleteCommonTemplate(): void {
        const formData: FormData = new FormData();
        //User Fields
        formData.append(
            'documentFields',
            JSON.stringify({
                documentId: this.form.DdjTemplate.documentId,
            })
        );

        this.documentsService
            .deleteCommonTemplate$(formData)
            .pipe(takeWhile(() => this.isComponentAlive))
            .subscribe((forms: DdjDocumentCore[]) => {
                this.viewState = ViewState.confirm;
                this.forms = forms;
            });
    }

    deleteTemplate(): void {
        const formData: FormData = new FormData();
        //User Fields
        formData.append(
            'documentFields',
            JSON.stringify({
                dealerId: this.form.dealerId,
                systemDocument: this.form.DdjTemplate.systemDocument,
                documentId: this.form.DdjTemplate.documentId,
            })
        );

        this.documentsService
            .deleteTemplate$(formData)
            .pipe(takeWhile(() => this.isComponentAlive))
            .subscribe((forms: DdjDocumentCore[]) => {
                this.viewState = ViewState.confirm;
                this.forms = forms;
            });
    }

    cancel(): void {
        this.dialogRef.close();
    }

    close(): void {
        this.dialogRef.close(this.forms);
    }

    ellipseTempleteName(name) {
        if (name.length > 20) {
            return name.replace(name.substring(20), '...');
        } else {
            return name;
        }
    }

    ngOnDestroy(): void {
        this.isComponentAlive = false;
    }
}
